import {action, observable} from 'mobx';
import {ITopMenuDesignUIState} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignUIState';

export class TopMenuState implements ITopMenuDesignUIState
{
    @observable
    public isExpanded:boolean = true;

    @observable
    public isExpandingTransitionInProgress:boolean = false;

    @observable
    public isCollapsingTransitionInProgress:boolean = false;

    @observable
    public isLogoTransitionInProgress:boolean = false;

    public toDesignUIState():ITopMenuDesignUIState
    {
        return {
            isExpanded: this.isExpanded
        }
    }

    @action
    public fromDesignUIState(state:ITopMenuDesignUIState):void
    {
        this.isExpanded = state.isExpanded;
    }
}
